import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILoadUsers } from '@shared/interfaces/user.interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsUsersService {

  private settings_users$ = new BehaviorSubject<any[]>([]);
  private search_users$ = new Subject<string>();
  
  constructor(private http: HttpClient) { }

  listenUsersSearch() {
    return this.search_users$.asObservable();
  }

  setUsersSearch(search: string) {
    this.search_users$.next(search);
  }

  setSettingsUsers(users: any[]) {
    this.settings_users$.next(users);
  }

  getSettingsUsers() {
    return this.settings_users$.asObservable();
  }

  loadUsers(page = 1, count = 50, globalSearchString = ''){
    let url = environment.apiUrl + `/operator/users?page=${page}&count=${count}${globalSearchString}`;
    return this.http.get<ILoadUsers>(url);
  }

  editUser(user_id: number, body: any) {
    let url = environment.apiUrl + `/operator/users/${user_id}`;
    return this.http.post(url, body);
  }

  editPermissionGroup(user_id: number, body: any) {
    let url = environment.apiUrl + `/operator/editPermissionGroup/${user_id}`;
    return this.http.post(url, body);
  }

  deleteUser(user_id: number) {
    let url = environment.apiUrl + `/operator/users/${user_id}`;
    return this.http.delete(url);
  }

  searchUsers(page = 1, count = 50, search = ''){
    let url = environment.apiUrl + `/operator/users?page=${page}&count=${count}&search=${search}`;
    return this.http.get<ILoadUsers>(url);
  }

  filterUsers(page = 1, count = 50, queryParams: string){
    let url = environment.apiUrl + `/operator/users?page=${page}&count=${count}&${queryParams}`;
    return this.http.get<ILoadUsers>(url);
  }
}
